import { useNavigate } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";

export default function NotFoundPage() {
  const navigate = useNavigate();
  usePageTitle("الصفحة غير موجودة · بَلاغة");
  return (
    <div className="shell" data-testid="not-found-page">
      <div
        className="panel"
        style={{
          maxWidth: 560,
          margin: "80px auto",
          padding: 40,
          textAlign: "center",
          border: "1px solid #2a2640",
        }}
      >
        <div style={{ fontSize: 72, marginBottom: 10 }}>📜</div>
        <div
          style={{
            fontFamily: "'Reem Kufi', 'Amiri', serif",
            fontSize: 72,
            fontWeight: 700,
            color: "var(--gold, #c79c6a)",
            lineHeight: 1,
            marginBottom: 8,
          }}
        >
          404
        </div>
        <h1 style={{ fontSize: 24, marginBottom: 14 }}>الصفحة التي تَطلبها غير موجودة</h1>
        <p
          className="muted"
          style={{ lineHeight: 1.9, marginBottom: 22, fontSize: 15 }}
        >
          ربّما حُذف الرابط، أو غُيِّر، أو لم يُكتب صحيحًا. لا بأس — عُد إلى
          الرئيسيّة وابدأ من جديد.
        </p>
        <div
          style={{
            display: "flex",
            gap: 12,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn btn-primary"
            data-testid="notfound-go-home"
            onClick={() => navigate("/")}
            style={{ padding: "12px 22px", fontWeight: 700 }}
          >
            العودة إلى الرئيسيّة →
          </button>
          <button
            className="btn btn-ghost"
            data-testid="notfound-go-tracks"
            onClick={() => navigate("/tracks")}
            style={{ padding: "12px 22px" }}
          >
            استكشف المسارات
          </button>
        </div>
      </div>
    </div>
  );
}
